import { render, staticRenderFns } from "./record-list.vue?vue&type=template&id=5ae400ce&scoped=true&"
import script from "./record-list.vue?vue&type=script&lang=js&"
export * from "./record-list.vue?vue&type=script&lang=js&"
import style0 from "./record-list.vue?vue&type=style&index=0&id=5ae400ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae400ce",
  null
  
)

export default component.exports